import api from "./../../../api/api";

export const getQuotes = (data, { cancel } = {}) =>
  api.post("companies/life-quotes", data, { cancelToken: cancel });

export const getSeeDetails = productId =>
  api.get(`term_products/${productId}/term_knowmore_features`);
export const createCartApi = data => api.post(`term/cart-items`, data);
